<div class="menuLinkDs__cont" [class.disabled]="isDisabled" (click)="clickTrigger()">
  <div class="menuLinkDs__cont--top">
    <div class="menuLinkDs__cont--top-left">
      @if (icon) {
        <div class="menuLinkDs__icon">
          <app-ds-icon
            [icon]="icon"
            [size]="20"
            [color]="isDisabled ? iconFillColor.Disabled : iconFillColor.Primary">
          </app-ds-icon>
        </div>
      }
      <div class="menuLinkDs__title">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="isDisabled ? fontColor.Disabled : fontColor.Primary"
          [fontFamily]="isStrong ? fontFamily.SemiBold : fontFamily.Regular"
          [text]="title">
        </app-ds-typography>
        @if (hasNotification) {
          <div class="menuLinkDs__notification">
            <app-ds-icon
              [icon]="icons.BulletA"
              [size]="16"
              [color]="iconFillColor.Neon">
            </app-ds-icon>
          </div>
        }
      </div>
    </div>
    <div class="menuLinkDs__action">
      <app-ds-icon
        [icon]="icons.ChevronRight"
        [size]="18"
        [color]="isDisabled ? iconFillColor.Disabled : iconFillColor.Primary">
      </app-ds-icon>
    </div>
  </div>
  @if (subtitle) {
    <div class="menuLinkDs__cont--bottom">
      <app-ds-typography
        [size]="fontSize.XXXS"
        [color]="isDisabled ? fontColor.Disabled : fontColor.Secondary"
        [fontFamily]="fontFamily.Regular"
        [text]="subtitle">
      </app-ds-typography>
    </div>
  }
</div>